const DRAFT_PREFIX = "journalDraft_";

function draftKey(journalId) {
  return `${DRAFT_PREFIX}${journalId || "new"}`;
}

export function saveDraft(journalId, journal) {
  localStorage.setItem(draftKey(journalId), JSON.stringify(journal));
}

export function loadDraft(journalId) {
  const raw = localStorage.getItem(draftKey(journalId));
  return raw ? JSON.parse(raw) : null;
}

export function clearDraft(journalId) {
  localStorage.removeItem(draftKey(journalId));
}
